module.exports = __webpack_public_path__ + "img/logo.34c8b892.svg";